export class DatePatterns {

    public static readonly MOMENT_ISO_8601_PATTERN = 'YYYY-MM-DDTHH:mm:ss';
    public static readonly LOCAL_DATE_PATTERN = 'YYYY-MM-DD';

}
